/**
 * Validates that a URL is safe to open in a new window.
 * Only allows http:// and https:// protocols.
 * @param url - The URL to validate
 * @returns The URL if valid and safe, null otherwise
 */
export const validateSafeUrl = (
  url: string | null | undefined,
): string | null => {
  if (!url || typeof url !== 'string') {
    return null;
  }

  try {
    const parsedUrl = new URL(url);

    // Only allow http and https protocols
    if (!['http:', 'https:'].includes(parsedUrl.protocol)) {
      return null;
    }

    return url;
  } catch {
    // URL is malformed
    return null;
  }
};
